import { Action, IOWidget, nothing, Pair } from 'widgets-for-react'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { BlockData, CMSState } from '../../../cms/blocks/types.gen'
import { CustomBlock } from '../../../drupal/types_and_parser/custom_blocks.mod'
import { Block } from '../../../drupal/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../application.mod'
import { ExtraImages } from '../../utils/extra_images.mod'
import { carrouselBlock, carrouselBlockProps, carrouselBlockStyle } from './widgets/carrouselBlock'
import { personBlock, personBlockProps, personBlockStyle } from './widgets/personBlock.mod'
import {
  quoteBlock,
  quoteBlockProps,
  QuoteBlockStyle,
} from './widgets/quoteBlock.mod'
import {
  pressReleasesBlockProps,
  pressReleasesBlockStyle,
  pressReleasesBlock
} from './widgets/pressReleasesBlock'
import { hubspotIFrameBlock, HubspotIFrameProps, HubSpotFrameBlockStyle } from './widgets/hubspotIFrame'
import { formBlock, formBlockProps, formBlockStyle } from './widgets/formBlock'
import { mediaBlockProps, MediaBlockStyle, mediaBlock } from './widgets/mediaBlock.mod'
import { storiesBlock, storiesBlockProps, storiesBlockStyle } from './widgets/storiesBlock.mod'
import { timelineBlock, timelineBlockProps, timelineBlockStyle } from './widgets/timelineBlock.mod'
import { textImageBlock, textImageBlockProps, textImageBlockStyle } from './widgets/textImageBlock.mod'
import { textBlockProps, textBlockStyle, textBlock } from './widgets/textBlock.mod'
import { expandBlock, expandBlockProps, expandBlockStyle } from './widgets/expandBlock.mod'
import { reportsBlock, reportsBlockProps, reportsBlockStyle } from './widgets/reportsBlock.mod'
import { FormProps } from 'monadic_react'
import { ctaBlock, ctaBlockProps, ctaBlockStyle } from './widgets/ctaBlock.mod'
import { customSpacerBlock, customSpacerBlockProps, customSpacerBlockStyle } from './widgets/customSpacerBlock.mod'
import { GridHighlightBlock, GridHighlightBlockProps, GridHighlightBlockStyle } from './widgets/gridHighlightBlock'
import { factsAndFiguresBlock, factsAndFiguresBlockProps, factsAndFiguresBlockStyle } from './widgets/factsAndFiguresBlock.mod'
// import { featuredContentBlock, featuredContentBlockProps, featuredContentBlockStyle } from './widgets/featuredContentBlock.mod'
import { quotesBlock, quotesBlockProps, quotesBlockStyle } from './widgets/quotesBlock.mod'
import { latestUpdatesBlock, latestUpdatesBlockProps, latestUpdatesBlockStyle } from './widgets/latestUpdatesBlock.mod'
//add here your custom blocks definitions

export type CustomBlockData =
  | personBlock
  | carrouselBlock
  | quoteData
  | formBlockData
  | hubspotIFrameData
  | mediaBlockData
  | storiesBlockData
  | timelineBlockData
  | textImageBlockData
  | textBlockData
  | pressReleasesBlockData
  | expandBlockData
  | reportsBlockData
  | ctaBlockData
  | quotesBlockData
  | latestUpdatesBlockData
  // | featuredContentBlockData
  | customSpacerBlockData
  | factsAndFiguresBlockData
  | gridHighlightBlockData

export function isCustomBlockData<s, i>(b: BlockData<s, i> | CustomBlockData): b is CustomBlockData {
  return (
    b.kind == 'personBlock' ||
    b.kind == 'carrouselBlock' ||
    b.kind == 'formBlock' ||
    b.kind == 'quoteBlock' ||
    b.kind == 'pressReleasesBlock' ||
    b.kind == 'hubspotIFrameBlock' ||
    b.kind == 'mediaBlock' ||
    b.kind == 'storiesBlock' ||
    b.kind == 'timelineBlock' ||
    b.kind == 'textBlock' ||
    b.kind == 'textImageBlock' ||
    b.kind == 'expandBlock' ||
    b.kind == 'reportsBlock' ||
    b.kind == 'ctaBlock' ||
    b.kind == 'quotesBlock' ||
    b.kind == 'latestUpdatesBlock' ||
    // b.kind == 'featuredContentBlock' ||
    b.kind == 'customSpacerBlock' ||
    b.kind == 'factsAndFiguresBlock' ||
    b.kind == 'gridHighlightBlock'
  )
}

export function isCustomBlock<s, i>(b: Block | CustomBlock): b is CustomBlock {
  return b.kind == 'personBlock'
    || b.kind == 'grid_blocks_image'
    || b.kind == 'grid_blocks_plain'
    || b.kind == 'iframe'
    || b.kind == 'quote'
    || b.kind == 'text_with_image'
    || b.kind == "form"
    || b.kind == "reports_overview"
    || b.kind == "cta"
    || b.kind == "quotes"
    || b.kind == "latest_updates_block"
    // || b.kind == "featured_content"
    || b.kind == "custom_spacer"
    || b.kind == "facts_and_figures"
    || b.kind == "grid_highlight"
}

export function renderCustomBlock(
  block: CustomBlockData,
  public_state: PublicSiteState,
  key?: string
): IOWidget<
  CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>,
  Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>
> {
  return (s0) => {
    if (block.kind == 'personBlock') {
      return personBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'quoteBlock') {
      return quoteBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'pressReleasesBlock') {
      return pressReleasesBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'mediaBlock') {
      return mediaBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'storiesBlock') {
      return storiesBlock(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'textImageBlock') {
      return textImageBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'textBlock') {
      return textBlock(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'timelineBlock') {
      return timelineBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'carrouselBlock') {
      return carrouselBlock(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'customSpacerBlock') {
      return customSpacerBlock(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == "formBlock") {
      return formBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'hubspotIFrameBlock') {
      return hubspotIFrameBlock(block.value.fst, { style: block.value.snd })
    } else if (block.kind == 'expandBlock') {
      return expandBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0 as CMSState<CustomBlockData, ExtraImages, never>)(public_state)
    } else if (block.kind == 'reportsBlock') {
      return reportsBlock(block.value.fst, { style: block.value.snd })(s0)(public_state)
    } else if (block.kind == 'ctaBlock') {
      return ctaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0 as CMSState<CustomBlockData, ExtraImages, never>)
    } else if (block.kind == 'quotesBlock') {
      return quotesBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0 as CMSState<CustomBlockData, ExtraImages, never>)
    } else if (block.kind == 'latestUpdatesBlock') {
      return latestUpdatesBlock<CustomBlockData>(block.value.fst, { style: block.value.snd })(s0 as CMSState<CustomBlockData, ExtraImages, never>)
    // } else if (block.kind == 'featuredContentBlock') {
    //   return featuredContentBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0 as CMSState<CustomBlockData, ExtraImages, never>)
    } else if (block.kind == 'gridHighlightBlock') {
      return GridHighlightBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0 as CMSState<CustomBlockData, ExtraImages, never>)
    } else if (block.kind == 'factsAndFiguresBlock') {
      return factsAndFiguresBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0 as CMSState<CustomBlockData, ExtraImages, never>)
    } else {
      return nothing()
    }
  }
}

export type personBlock = { kind: 'personBlock'; value: Pair<personBlockProps, personBlockStyle> }
export type carrouselBlock = { kind: 'carrouselBlock'; value: Pair<carrouselBlockProps, carrouselBlockStyle> }
export type quoteData = { kind: 'quoteBlock'; value: Pair<quoteBlockProps, QuoteBlockStyle> }
export type hubspotIFrameData = { kind: 'hubspotIFrameBlock'; value: Pair<HubspotIFrameProps, HubSpotFrameBlockStyle> }
export type formBlockData = { kind: 'formBlock'; value: Pair<formBlockProps, formBlockStyle> }
export type mediaBlockData = { kind: 'mediaBlock'; value: Pair<mediaBlockProps, MediaBlockStyle> }
export type storiesBlockData = { kind: 'storiesBlock'; value: Pair<storiesBlockProps, storiesBlockStyle> }
export type timelineBlockData = { kind: 'timelineBlock'; value: Pair<timelineBlockProps, timelineBlockStyle> }
export type textImageBlockData = { kind: 'textImageBlock'; value: Pair<textImageBlockProps<CustomBlockData, ExtraImages>, textImageBlockStyle> }
export type textBlockData = { kind: 'textBlock'; value: Pair<textBlockProps, textBlockStyle> }
export type pressReleasesBlockData = { kind: 'pressReleasesBlock'; value: Pair<pressReleasesBlockProps, pressReleasesBlockStyle> }
export type expandBlockData = { kind: 'expandBlock'; value: Pair<expandBlockProps<CustomBlockData, ExtraImages>, expandBlockStyle> }
export type reportsBlockData = { kind: 'reportsBlock'; value: Pair<reportsBlockProps, reportsBlockStyle> }
export type ctaBlockData = { kind: 'ctaBlock'; value: Pair<ctaBlockProps<ExtraImages>, ctaBlockStyle> }
export type quotesBlockData = { kind: 'quotesBlock'; value: Pair<quotesBlockProps, quotesBlockStyle> }
export type latestUpdatesBlockData = { kind: 'latestUpdatesBlock'; value: Pair<latestUpdatesBlockProps, latestUpdatesBlockStyle> }
// export type featuredContentBlockData = { kind: 'featuredContentBlock'; value: Pair<featuredContentBlockProps<ExtraImages>, featuredContentBlockStyle> }
export type customSpacerBlockData = { kind: 'customSpacerBlock'; value: Pair<customSpacerBlockProps, customSpacerBlockStyle> }
export type factsAndFiguresBlockData = { kind: 'factsAndFiguresBlock'; value: Pair<factsAndFiguresBlockProps, factsAndFiguresBlockStyle> }
export type gridHighlightBlockData = { kind: 'gridHighlightBlock'; value: Pair<GridHighlightBlockProps, GridHighlightBlockStyle> }
